<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="projectdetails"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      width="250px"
      mobile-break-point="0"
      floating
      app>
      <div class="h-100 d-flex flex-column page-drawer">
        <div class="page-logo-container mx-auto my-5">
          <!-- DelMar Logo -->
          <router-link
            id="logo"
            to="/content">
            <img
              src="../assets/img/logo.png"
            />
          </router-link>
          <!-- / DelMar Logo -->
        </div>

        <div class="page-navigation-container d-flex flex-column flex-grow-1">
          <!-- Main Navigation -->
            <MainNavigation />
          <!-- / Main Navigation -->
        </div>

        <!-- User Account Menu -->
            <UserMenu class="mt-auto" />
        <!-- User Account Menu -->
      </div>
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Project Page Content -->
    <v-content class="h-100">
      <v-toolbar
        class="my-2 page-toolbar">
        <v-app-bar-nav-icon
          class="page-drawer-toggle"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <h4 class="d-flex align-center margin-right">
            {{$store.state.user.projectName}}
          </h4>
        </v-toolbar-title>

        <!-- Preview / Publish -->
          <PreviewPublish />
        <!-- / Preview / Publish -->

        <v-spacer></v-spacer>

      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <!-- Project List -->
        <ProjectSettingsList />
      <!-- / Project List -->
    </v-content>
    <!-- / Project Page Content -->
  </div>
</template>

<script>
import MainNavigation from '../components/MainNavigation.vue';
import UserMenu from '../components/UserMenu.vue';
import ProjectSettingsList from '../components/ProjectSettingsList.vue';
import PreviewPublish from '../components/PreviewPublish.vue';

export default {
  name: 'ProjectSettings',
  components: {
    MainNavigation,
    UserMenu,
    ProjectSettingsList,
    PreviewPublish,
  },
  data() {
    return {
      isDrawerOpen: true,
    };
  },
};
</script>
